// « S'exercer » (DRILL) — lancement d'un exercice depuis un point d'entrée (débrief / historique /
// Progrès). Écrit le contexte dans localStorage (consommé par DrillPage) puis navigue vers la page.
// Modèle : bizcoach_pending_path_phase (parcours certifiants).

import type { PageType } from "../types";
import { isDrillVisible } from "./drill-visibility";

export type DrillLaunchContext = {
  criterionKey: string;
  criterionLabel: string;
  simulatorId: string;
  simulatorLabel?: string;
  origin: "feedback" | "history" | "progress";
  sourceSessionId?: string;   // session de simulation d'origine (débrief) — pour le quota offert
  exerciseSheetId?: string;
};

const PENDING_KEY = "bizcoach_pending_drill";

export function launchDrill(ctx: DrillLaunchContext, navigate: (page: PageType) => void) {
  // S'exercer fermé (interrupteur, `drill-visibility.ts`) : aucun lancement, même depuis un lien resté affiché.
  if (!isDrillVisible()) return;
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify({ ...ctx, createdAt: Date.now() }));
  } catch { /* ignore quota localStorage */ }
  navigate("drill");
}

// Parmi une liste de critères notés (0-10 ou 0-100), renvoie les clés des 3 « plus forte marge de
// progression » (scores les plus bas) qui sont AUSSI éligibles (fiche d'exercice active).
export function lowest3Drillable(
  items: { key: string; score: number }[],
  eligibleKeys: Set<string>,
): Set<string> {
  return new Set(
    [...items]
      .filter((c) => eligibleKeys.has(c.key))
      .sort((a, b) => a.score - b.score)
      .slice(0, 3)
      .map((c) => c.key),
  );
}
